import type { FindOperationLogByItineraryInput } from '@travel-planner/shared/schemas/operation-log';
import { trpc } from '@/shared/api/trpc';

type Options = {
  enabled?: boolean;
};

export const useOperationLogByItineraryData = (
  input: FindOperationLogByItineraryInput,
  options?: Options
) =>
  trpc.operationLog.findByItinerary.useQuery(input, {
    enabled: options?.enabled ?? true,
    // Logs change constantly via other mutations; the global 5-min staleTime
    // would otherwise show a cached list until a full refresh. Always refetch
    // so reopening the modal shows the latest entries.
    staleTime: 0,
    refetchOnMount: 'always',
  });
